import type {
  CreateWorkspaceMembershipInput,
  UpdateWorkspaceMembershipInput,
  WorkspaceMembership,
  WorkspaceMembershipInviteResult,
  WorkspaceMembershipUserIdInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createWorkspaceMembershipClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({ workspaceId }: { workspaceId: string }) => {
      return request<WorkspaceMembership[]>({
        method: "GET",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/membership`,
      });
    },
    create: ({
      workspaceId,
      ...input
    }: { workspaceId: string } & CreateWorkspaceMembershipInput) => {
      return request<WorkspaceMembershipInviteResult>({
        method: "POST",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/membership/invite`,
        body: input,
      });
    },
    update: ({
      workspaceId,
      ...input
    }: { workspaceId: string } & UpdateWorkspaceMembershipInput) => {
      return request<WorkspaceMembership[]>({
        method: "POST",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/membership/update`,
        body: input,
      });
    },
    delete: ({
      workspaceId,
      ...input
    }: { workspaceId: string } & WorkspaceMembershipUserIdInput) => {
      return request<WorkspaceMembership[]>({
        method: "POST",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/membership/delete`,
        body: input,
      });
    },
    resendInvite: ({
      workspaceId,
      ...input
    }: { workspaceId: string } & WorkspaceMembershipUserIdInput) => {
      return request<{ success: boolean }>({
        method: "POST",
        path: `/api/v1/workspaces/${encodeURIComponent(workspaceId)}/membership/resend-invite`,
        body: input,
      });
    },
  };
}
